import React from 'react'
import Link from 'next/link'

import styles from './categoriesList.module.scss'

import { CategoryNameConverter } from '@utils'

const CategoriesList = ({ data }) => {
  if (!data || !data.categories) return null
  const allCategories = Object.keys(data?.categories || {}).filter((c) => c !== '__typename')

  return (
    <div className={styles.categoriesListContainer}>
      <div className={styles.data}>
        <h2 className={styles.title}>Explore by Category</h2>
        <div className={styles.list}>
          {allCategories.map((category, i) => (
            <div key={i} className={styles.link}>
              <Link href={`puppies-for-sale/${category}`} prefetch={false}>
                <p>{CategoryNameConverter(category)}</p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CategoriesList
